import Cookies from 'js-cookie';
const ursDatabaseIdRegex = /URS_DATABASE_ID=([A-F0-9]{8}(?:-[A-F0-9]{4}){3}-[A-F0-9]{12}|[A-F0-9]{32})/;
export const parseCookies = (cookieName, isRegex = false) => {
    const pairs = document.cookie.split(';');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cookies = {};
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=');
        cookies[(pair[0] + '').trim()] = unescape(pair[1]);
    }
    if (!isRegex) {
        return cookies[cookieName] || '';
    }
    else {
        const cookieNameRegex = new RegExp(cookieName);
        const key = Object.keys(cookies).find((it) => it.match(cookieNameRegex));
        if (key) {
            return cookies[key];
        }
        return '';
    }
};
export const getUrsDatabaseIdFromCookie = () => {
    const cookieString = parseCookies('user');
    if (cookieString) {
        const ursId = ursDatabaseIdRegex.exec(decodeURIComponent(cookieString));
        return ursId ? ursId[1] : '';
    }
    return '';
};
export const getSessionIdFromCookie = () => {
    const cookieString = parseCookies('^_sp_id\\.\\w{4}$', true);
    return cookieString ? cookieString.split('.')[5] : '';
};
export const getNetworkIdFromCookie = () => {
    const networkId = parseCookies('sp');
    return networkId || '';
};
export const validateAndParseContexts = (contexts, events) => {
    try {
        const parsedContexts = JSON.parse(contexts.toString());
        parsedContexts.forEach((context) => {
            context.schema && context.data && events.push(context);
        });
    }
    catch (_a) {
        console.error('contexts prop is not in the correct format to parse');
    }
    return events;
};
export const vdsVehicleInfoFieldExists = (trackingData) => {
    return !!(trackingData['generation_id'] ||
        trackingData['derivative_id'] ||
        trackingData['standard_make'] ||
        trackingData['standard_model'] ||
        trackingData['standard_body_type'] ||
        trackingData.fuel_type ||
        trackingData['standard_is_crossover'] ||
        trackingData['colour'] ||
        trackingData['transmission'] ||
        trackingData['standard_drivetrain'] ||
        trackingData['standard_engine_size_cc'] ||
        trackingData['standard_engine_size_litre'] ||
        trackingData['standard_engine_size_unit'] ||
        trackingData['axle_config'] ||
        trackingData['cab_type'] ||
        trackingData['emission_class'] ||
        trackingData['standard_style'] ||
        trackingData['standard_sub_style'] ||
        trackingData['standard_trim'] ||
        trackingData['standard_layout_bed'] ||
        trackingData['standard_layout_end'] ||
        trackingData['wheelbase_type']);
};
export var ListingType;
(function (ListingType) {
    ListingType["FEATURED_LISTING"] = "FEATURED_LISTING";
    ListingType["LEASING_LISTING"] = "LEASING_LISTING";
    ListingType["NATURAL_LISTING"] = "NATURAL_LISTING";
    ListingType["PROMOTED_LISTING"] = "PROMOTED_LISTING";
    ListingType["YOU_MAY_ALSO_LIKE"] = "YOU_MAY_ALSO_LIKE";
    ListingType["HOME_SCREEN_LISTING"] = "HOME_SCREEN_LISTING";
    ListingType["SEO_LISTING"] = "SEO_LISTING";
    ListingType["GPT_LISTING"] = "GPT_LISTING";
    ListingType["PRE_LAUNCH_MARKETING"] = "PRE_LAUNCH_MARKETING";
    ListingType["NEW_CAR_DEALS"] = "NEW_CAR_DEALS";
})(ListingType || (ListingType = {}));
const listingTypes = new Map();
listingTypes.set(ListingType.FEATURED_LISTING, 'featured-listing');
listingTypes.set(ListingType.PROMOTED_LISTING, 'promoted');
listingTypes.set(ListingType.YOU_MAY_ALSO_LIKE, 'ymal');
listingTypes.set(ListingType.LEASING_LISTING, 'ls');
listingTypes.set(ListingType.NATURAL_LISTING, 'STANDARD_ADVERT');
listingTypes.set(ListingType.HOME_SCREEN_LISTING, 'home-screen');
listingTypes.set(ListingType.SEO_LISTING, 'seo');
export const setSearchJourneyCookie = (type, advertId) => {
    const cookieExpiry = 10 / 86400; // 10 seconds
    const listingType = listingTypes.get(type);
    if (listingType === undefined) {
        return;
    }
    const searchJourneyValue = advertId ? `${listingType}__${advertId}` : listingType;
    Cookies.set('searchJourney', searchJourneyValue, { expires: cookieExpiry });
};
